import { buildMatchPath } from "pages/PageConfigs";
import { MatchFormat } from "./Parts/MatchFormat/MatchFormat";
import { MatchTeams } from "./Parts/MatchTeams/MatchTeams";
import { MatchTime } from "./Parts/MatchTime/MatchTime";
import { StatusPill } from "./Parts/StatusPill/StatusPill";
import { TournamentDetails } from "./Parts/TournamentDetails/TournamentDetails";
import {
  MatchContainer,
  MatchFormatContainer,
  MatchTeamsContainer,
  MatchTimeContainer,
  StatusPillContainer,
  TournamentDetailsContainer,
  TournamentLogoContainer,
} from "./styles";
import { Match } from "model/Match/Match";
import { TournamentLogo } from "components/Logo/TournamentLogo";
import { PlainNavLink } from "styles/elements";

interface Props {
  match: Match;
  tournamentId: string;
  showTrackScores: boolean;
  includeDay?: boolean;
}

export const MatchListItem = ({
  match,
  tournamentId,
  showTrackScores,
  includeDay,
}: Props) => {
  return (
    <PlainNavLink to={buildMatchPath(match.id)}>
      <MatchContainer>
        <MatchTimeContainer>
          <MatchTime timeMs={match.startTimeMs} includeDay={includeDay} />
        </MatchTimeContainer>

        <MatchTeamsContainer>
          <MatchTeams
            match={match}
            tournamentId={tournamentId}
            showTrackScores={showTrackScores}
          />
        </MatchTeamsContainer>

        {!!tournamentId && (
          <>
            <TournamentLogoContainer>
              <TournamentLogo id={tournamentId} />
            </TournamentLogoContainer>

            <TournamentDetailsContainer>
              <TournamentDetails
                matchId={match.id}
                tournamentId={tournamentId}
                includeMatchPart={false}
              />
            </TournamentDetailsContainer>
          </>
        )}

        <MatchFormatContainer>
          <MatchFormat match={match} />
        </MatchFormatContainer>

        <StatusPillContainer>
          <StatusPill match={match} />
        </StatusPillContainer>
      </MatchContainer>
    </PlainNavLink>
  );
};
